enum EnvironmentEnum {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
  REVIEW = 'review',
  REVIEW_APP = 'review-app',
  STAGING = 'staging',
  TREINAMENTO = 'treinamento',
}

export default EnvironmentEnum;
